import { type FC, type ReactNode, useRef } from "react";
import { type AriaDialogProps, useDialog } from "react-aria";

export const CalendarPopoverDialog: FC<AriaDialogProps & { children: ReactNode }> = ({
	children,
	...props
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const { dialogProps } = useDialog(props, ref);

	return (
		<div {...dialogProps} ref={ref}>
			{children}
		</div>
	);
};
